module.exports = __webpack_public_path__ + "shell/assets/images/providers/pinganyunecs-black.svg";